import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormControl } from '../../providers/formbuilder/formcontrol.interface';
import { DynamicFormBuilder } from '../../providers/formbuilder/dynamic-form-builder';
import { IDictionary } from '../../model/models/dictionary.interface';

@Component({
  selector: 'rmt-dynamic-form',
  templateUrl: 'rmt-dynamic-form.html'
})
export class RmtDynamicFormComponent {
  @ViewChild('inputs') inputs;
  @Input() fields: IFormControl[];
  @Input() sanitizeFields: [string];
  @Input() stepFields;
  @Input() values;
  @Input() newDesign: boolean;
  @Input() clearOnFocus: boolean;
  @Output() ionChange = new EventEmitter<IDictionary>();
  @Output() formBuiltEmitter = new EventEmitter<any>();
  form: FormGroup = new FormGroup({});
  lastFields: IFormControl[];

  constructor() {
  }

  ngOnChanges() {
    if (this.fields !== this.lastFields) {
      this.form = new FormGroup({});
      if (this.lastFields) {
        for (let i=0; i < this.lastFields.length; i++) {
          this.form.removeControl(this.lastFields[i].id);
        }
      }
      RmtDynamicFormComponent.addFieldsToForm(this.fields, this.form);
      if (this.values) {
        this.form.patchValue(this.values);
        for(let field of this.fields) {
          field.value = this.form.controls[field.id].value;
        }
      }
    }
    this.lastFields = this.fields;
    this.formBuiltEmitter.emit(this.form);
  }

  getPayload() {
    return this.form.getRawValue();
  }

  static addFieldsToForm(fields: IFormControl[], form: FormGroup, errorFields?: any[]) {
    const builder = new DynamicFormBuilder(fields);
    if (fields) {
      if(Object.keys(form.controls).length > 0) fields.forEach(field => field.value = form.controls[field.id].value);
      if(errorFields) {
        errorFields.forEach(field => {
          let formControl = form.controls[field.FieldId];
          if(formControl) {
            formControl.setErrors({ 'invalidField': field.TranslatedErrorMessage });
            formControl.markAsTouched();
          }
        })
      }
      else {
        const controls = builder.buildAbstractControls(fields, errorFields);
        for (const id in controls) {
          form.addControl(id, controls[id]);
        }
      }
    }
  }

  changedField($event, originalField) {
    const phone = originalField.phoneParts ? originalField.phoneParts : undefined;
    const field = ($event && $event.id !== '') ? $event : originalField; // added this to handle the values passed in case of loqate address change.

    let value = field.numberPhoneValue ? field.numberPhoneValue : undefined;
    if(!value && field.id) {
      value = this.form.controls[field.id].value;
    }
    this.ionChange.emit({ text: field.id, value, phone });
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-dynamic-form/rmt-dynamic-form.ts